module.exports = {
    eventColor: {
        COLOR: 'color',
        COLOR_PALE: 'color-pale',
        NO_COLOR: 'no-color'
    },

    taskColor: {
        PROJECT: 'project',
        STATUS: 'status',
        NO_COLOR: 'no-color'
    },
};